import { render, staticRenderFns } from "./SwappDirection.vue?vue&type=template&id=78986696&"
import script from "./SwappDirection.vue?vue&type=script&lang=js&"
export * from "./SwappDirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports